import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import Loader from "react-loader-spinner";
import * as Yup from "yup";
import "./Withdrawal-pages.css";
import { Link } from "react-router-dom";
import {
  StyledBankTransferFormButton,
  ButtonGroup,
  colors,
} from "../../../../../Syles/styles";
import { BankTranferDetailsTextInput } from "../../../../Formik/BankDetailsInput";
import BankTranferDetailsSelect from "../../../../Formik/BankDetailsSelect";
import { $api } from "../../../../../../helpers/$api";
import { Util } from "../../../../../../helpers/util";
import { BANK_WITHDRAW } from "../../../../../../constants";

const BAnkAccountMethod = ({ setStage }) => {
  const [balance, setBalance] = useState(0);
  const [banks, setBanks] = useState([]);
  const initialValues = Util.get(BANK_WITHDRAW, {
    amount: "",
    bank_id: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const { ovest } = await $api.user.getBalances();
        const banks = await $api.user.getSavedBanks();

        setBanks(banks);
        setBalance(ovest);
      } catch (error) {
        // error...
      }
    })();
  }, [setBalance, setBanks]);

  const changeStage = (values) => {
    Util.set(BANK_WITHDRAW, values);
    setStage(2);
  };
  const { currency } = Util.getCurrency();
  return (
    <div
      style={{
        height: "90vh",
      }}
    >
      <div
        className="BankAccountMethod"
        style={{
          marginTop: "40px",
          marginBottom: "23px",
          width: "90%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Formik
          initialValues={initialValues}
          onSubmit={(values, { setSubmitting, setFieldError }) => {
            console.log(values);
            changeStage(values);
            // loginUser(values, history, setFieldError, setSubmitting);
          }}
          validationSchema={Yup.object({
            amount: Yup.string().required(" Amount Field is Required"),
            bank_id: Yup.string().required(" Bank Field is Required"),
          })}
        >
          {({ isSubmitting }) => (
            <Form>
              <h5 className="bam-h5">Withdraw to Bank Account</h5>
              <p className="bam-p">
                How much would you like to withdraw from your wallet?{" "}
              </p>
              <BankTranferDetailsTextInput
                name="amount"
                type="tel"
                placeholder={currency}
              />

              <p className="savestform-p">
                Wallet Balance:{" "}
                <span>
                  {" "}
                  {currency}
                  {balance}
                </span>
              </p>

              <p
                style={{
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "14px",
                  lineHeight: "20px",

                  letterSpacing: "0.03em",

                  color: "#121212",
                }}
              >
                Select bank account{" "}
              </p>

              <div class="select">
                <BankTranferDetailsSelect name="bank_id" id="standard-select">
                  <option value="" disabled selected hidden>
                    Select Bank
                  </option>
                  {banks.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.Account_name}
                    </option>
                  ))}
                </BankTranferDetailsSelect>

                <span class="focus"></span>
              </div>
              <p
                style={{
                  marginTop: "20px",
                  fontSize: "14px",
                  lineHeight: "22px",
                  color: "#666666",
                  letterSpacing: "0.03em",
                  textAlign: "left",
                  width: "353px",
                  height: "44px",
                }}
              >
                Can't find your bank account?
                <span
                  style={{
                    color: "#267bf7",
                  }}
                >
                  <Link to="/dashboard/account/banksandcards">
                    Transfer to a new account
                  </Link>
                </span>
              </p>

              <ButtonGroup>
                {!isSubmitting && (
                  <StyledBankTransferFormButton type="submit">
                    Send
                  </StyledBankTransferFormButton>
                )}

                {isSubmitting && (
                  <Loader
                    type="ThreeDots"
                    color={colors.primary}
                    height={49}
                    width={100}
                  />
                )}
              </ButtonGroup>
            </Form>
          )}
        </Formik>

        <div className="bnm-notice">
          <p>
            Kindly note that a transaction fee of N10.00 would be deducted from
            your wallet
          </p>
        </div>
      </div>
    </div>
  );
};

export default BAnkAccountMethod;
